import { render, staticRenderFns } from "./NewRedeemProduk.vue?vue&type=template&id=25cb5fc2&scoped=true"
import script from "./NewRedeemProduk.vue?vue&type=script&lang=js"
export * from "./NewRedeemProduk.vue?vue&type=script&lang=js"
import style0 from "./NewRedeemProduk.vue?vue&type=style&index=0&id=25cb5fc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cb5fc2",
  null
  
)

export default component.exports